import { createSelector } from "reselect";

const selectData = (state) => state.home;

export const selectHomeData = createSelector([selectData], (home) => {
  return {
    initialSynced: home.initialSynced,
    syncingHome: home.syncingHome,
    message: home.message,
    bannerList: home.bannerList,
  };
});

export const selectThingData = createSelector([selectData], (home) => {
  return {
    thingMessage: home.thingMessage,
    thingList: home.thingList,
    syncingThing: home.syncingThing,
  };
});

export const selectFavoriteData = createSelector([selectData], (home) => {
  return {
    favoriteMessage: home.favoriteMessage,
    favoriteList: home.favoriteList,
    syncingFavorite: home.syncingFavorite,
  };
});

export const selectHomeSlideId = createSelector([selectData], (home) => {
  return home.homeSlideId;
});

export const selectemployeeData = createSelector([selectData], (home) => {
  return home.employeeData;
});

export const selectOverlayFlags = createSelector([selectData], (home) => {
  return {
    showRegisterOverlayFlag: home.showRegisterOverlayFlag,
    showSigninOverlayFlag: home.showSigninOverlayFlag,
    showAccountOverlayFlag: home.showAccountOverlayFlag,
    showForgotPasswordOverlayFlag: home.showForgotPasswordOverlayFlag,
    showResetPasswordOverlayFlag: home.showResetPasswordOverlayFlag,
  };
});
